import React from 'react';
import ReactDataGrid from 'react-data-grid';
import {Editors} from 'react-data-grid-addons';
import {faFile, faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Modal from "../components/Modal";
import DecisionMatrixForm from "../forms/DecisionMatrixForm";
import {userFio} from "../utils/userUtils";
import TableDataGrid from "../components/TableDataGrid";

const {DropDownEditor} = Editors;

const {
    Draggable: {
        Container: DraggableContainer,
        RowActionsCell,
        DropTargetRowContainer
    },
    Data: {Selectors}
} = require('react-data-grid-addons');
// const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

const RowRenderer = ({ renderBaseRow, ...props }) => {
    let height = 35;
    if (props.row.person_violator_ids) {
        if (props.row.person_violator_ids.length > 1) {
            height = props.row.person_violator_ids.length * 24;
        }
    }
    return <div>{renderBaseRow({...props, height: height})}</div>;
};

const zeroTabbed = (value) => `0${value}`.slice(-2);

class DecisionMatrixTableForm extends React.Component {
    constructor(props) {
        super(props);
        this.resolveTypes = [
            {id: 0, value: 'Пропустить'},
            {id: 1, value: 'Зафиксировать'},
        ];
        const ResolveTypeEditor = <DropDownEditor options={this.resolveTypes}/>;


        // создаю список параметров для выбора объекта наблюдения
        this.objectObservation = [{id: null, value: 'Все'}];
        if (this.props.objects) {
            for (const obj of this.props.objects) {
                this.objectObservation.push({id: obj.id, value: `${obj.name} (${obj.power_unit.name})`});
            }
        }
        // создаю список параметров для выбора зоны
        const ObjectsObservationEditor = <DropDownEditor options={this.objectObservation}/>;


        this.zoneTypes = [{id: null, value: 'Все'}];
        if (this.props.modelstorage.config_zones) {
            for (const zone of this.props.modelstorage.config_zones) {
                this.zoneTypes.push({id: zone.zone_id_cfg, value: zone.zone_name_cfg});
            }
        }
        const ZoneTypeEditor = <DropDownEditor options={this.zoneTypes}/>;

        // создаю список параметров для камеры
        this.cameraTypes = [{id: null, value: 'Все'}];
        if (this.props.cameras) {
            for (const camera of this.props.cameras) {
                let object_observation_id = null;
                if (camera.obj_id) {
                    object_observation_id = camera.obj_id;
                }
                this.cameraTypes.push({
                    id: camera.id,
                    value: `${camera.name} (${camera.obj.name}) (${camera.power_unit.name})`,
                    object_observation_id: object_observation_id
                });
            }
        }
        // const CameraTypeEditor = <DropDownEditor options={this.cameraTypes} />;

        // создаю список параметров для выбора категории
        this.primaryCategoryTypes = [{id: null, value: 'Все'}];
        if (this.props.modelstorage.primary_categories) {
            for (const category of this.props.modelstorage.primary_categories) {
                this.primaryCategoryTypes.push({id: category.name, value: category.ru_name});
            }
        }
        const PrimaryCategoryTypeEditor = <DropDownEditor options={this.primaryCategoryTypes}/>;

        // создаю список параметров для выбора подкатегории
        this.secondaryCategoryTypes = [{id: null, value: 'Все'}];
        if (this.props.modelstorage.secondary_categories) {
            for (const category of this.props.modelstorage.secondary_categories) {
                this.secondaryCategoryTypes.push({id: category.name, value: category.ru_name});
            }
        }
        const SecondaryCategoryTypeEditor = <DropDownEditor options={this.secondaryCategoryTypes}/>;

        // создаю список параметров для время
        this.timeOptions = [{id: null, value: 'Все'}];
        for (let hour = 0; hour < 24; hour += 1) {
            for (let minute = 0; minute < 60; minute += 5) {
                this.timeOptions.push({
                    id: `${zeroTabbed(hour)}:${zeroTabbed(minute)}:00`,
                    value: `${zeroTabbed(hour)}:${zeroTabbed(minute)}:00`
                });
            }
        }
        const TimeTypeEditor = <DropDownEditor options={this.timeOptions}/>;

        this.state = {
            isDirty: false,
            rows: this.toSelectValue(props.dataRows),
            editingId: null,
            selectedIds: [],
            selectedCamerasObjectObservation: this.cameraTypes,
        };

        const CameraTypeEditor = <DropDownEditor options={this.state.selectedCamerasObjectObservation}/>;

        const emploeeActive = (val) => {
            if (val.value) {
                return val.value.map(item => {
                    return <div>{userFio(this.props.employees.find(empI => empI.id === item))}</div>
                })
            } else {
                return <p></p>
            }
        }

        this.columns = [{
            key: 'priority',
            name: 'Приоритет',
            draggable: true,
            width: 85,
        }, {
            key: 'object_observation',
            name: 'Помещение',
        }, {
            key: 'camera',
            name: 'Камера',
        }, {
            key: 'primary_category',
            name: 'Первичная категория',
        }, {
            key: 'zone_config',
            name: 'Зона',
            width: 100,
        }, {
            key: 'secondary_category',
            name: 'Вторичная категория',
        }, {
            key: 'time_from',
            name: 'Время от',
            width: 85,
        }, {
            key: 'time_to',
            name: 'Время до',
            width: 85,
        }, {
            key: 'cron_datetime',
            name: 'Кронтаб',
            width: 95,
        }, {
            key: 'event_threshold',
            name: `Пороговое значение`,
            width: 150,
        }, {
            key: 'person_violator_ids',
            name: 'Список работников',
            formatter: cell => emploeeActive(cell),
            width: 150,
        }, {
            key: 'solution',
            name: 'Решение',
            width: 150,
        }];
    }

    preSave = (e) => {
        e.preventDefault();
        const rows = this.fromSelectValue(this.state.rows);
        this.props.handleSave(rows)
    }

    toSelectValue = (data) => {
        let modifedRows = [];
        const dataRows = [...data];

        const secondsToTimeString = (totalSeconds) => {
            if (totalSeconds === null || totalSeconds === -1) {
                return "Все";
            }
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
            const seconds = 0;
            const hh = zeroTabbed(hours);
            const mn = zeroTabbed(minutes);
            const ss = zeroTabbed(seconds);
            return `${hh}:${mn}:${ss}`;
        };

        for (const row of dataRows) {
            for (const solution of this.resolveTypes) {
                if (row['solution'] === solution.id) {
                    row['solution'] = solution.value;
                }
            }
            for (const zone of this.zoneTypes) {
                if (row['zone'] === zone.id) {
                    row['zone_config'] = zone.value;
                }
            }
            for (const category of this.primaryCategoryTypes) {
                if (row['primary_category'] === category.id) {
                    row['primary_category'] = category.value;
                    row['primary_category_id'] = category.id;
                }
            }
            for (const category of this.secondaryCategoryTypes) {
                if (row['secondary_category'] === category.id) {
                    row['secondary_category'] = category.value;
                    row['secondary_category_id'] = category.id;
                }
            }
            for (const camera of this.cameraTypes) {
                if (row['camera_id'] === camera.id) {
                    row['camera'] = camera.value;
                }
            }
            for (const obj of this.objectObservation) {
                if (row['object_observation_id'] === obj.id) {
                    row['object_observation'] = obj.value;
                }
            }
            row['time_from'] = secondsToTimeString(row['time_from']);
            row['time_to'] = secondsToTimeString(row['time_to']);
            modifedRows.push(row);
        }
        return modifedRows;
    }

    fromSelectValue = (data) => {
        console.debug('fromSelectValue> ', data)
        const rows = [...data];

        const timeStringToSeconds = (time) => {
            if (time === "" || time === "Все") {
                return -1;
            }

            const [hours, minutes, seconds] = time.split(':').join('').match(/.{1,2}/g);
            return parseInt(seconds, 10) +
                parseInt(minutes, 10) * 60 +
                parseInt(hours, 10) * 60 * 60;
        };

        for (const row of rows) {
            for (const solution of this.resolveTypes) {
                if (row['solution'] === solution.value) {
                    row['solution'] = solution.id;
                }
            }
            for (const zone of this.zoneTypes) {
                if (row['zone_config'] === zone.value) {
                    row['zone'] = zone.id;
                }
            }
            for (const category of this.primaryCategoryTypes) {
                if (row['primary_category'] === category.value) {
                    row['primary_category'] = category.id;
                }
            }
            for (const category of this.secondaryCategoryTypes) {
                if (row['secondary_category'] === category.value) {
                    row['secondary_category'] = category.id;
                }
            }
            for (const camera of this.cameraTypes) {
                if (row['camera'] === camera.value) {
                    row['camera_id'] = camera.id;
                }
            }
            for (const obj of this.objectObservation) {
                if (row['object_observation'] === obj.value) {
                    row['object_observation_id'] = obj.id;
                }
            }
            row['event_threshold'] = parseInt(row['event_threshold']);
            row['cron_datetime'] = row['cron_datetime']?.trim();
            row['time_from'] = timeStringToSeconds(row['time_from']);
            row['time_to'] = timeStringToSeconds(row['time_to']);
        }
        return rows;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            rows: this.toSelectValue(nextProps.dataRows),
            selectedIds: [],
        });
    }

    addRules = (e) => {
        e.preventDefault();

        const rows = [...this.state.rows];
        const last = rows[rows.length - 1];

        let item = null;
        if (rows.length) {
            item = {...last};
            item.priority = parseInt(item.priority) + 1;
        } else {
            item = {priority: 1};
        }
        item.camera = this.cameraTypes[0].value;
        item.object_observation = this.objectObservation[0].value;
        item.primary_category = this.primaryCategoryTypes[0].value;
        item.secondary_category = this.secondaryCategoryTypes[0].value;
        item.time_from = this.timeOptions[0].value;
        item.time_to = this.timeOptions[0].value;
        item.cron_datetime = "";
        item.zone_config = this.zoneTypes[0].value;
        item.solution = this.resolveTypes[0].value;
        item.event_threshold = 50;
        item.person_violator_ids = null;

        rows.push(item);
        this.setState({
            modalOpen: true,
            row: item,
            editingId: -1,
        });

        // this.updateRows(rows);
    }

    onCellSelected = ({rowIdx, idx}) => {
        console.debug('onCellSelected>', rowIdx, idx, this.state.rows[rowIdx]);
        const row = this.state.rows[rowIdx];

        if (row && row.object_observation) {
            const selectedObjectObservationId = row.object_observation.id;
            let cameras = [];
            for (const camera of this.cameraTypes) { // в селекторе только камеры данного объекта наблюдения
                if (camera.object_observation_id === selectedObjectObservationId) {
                    cameras.push(camera);
                }
            }
            this.setState({
                selectedCamerasObjectObservation: cameras,
            })
        } else {
            this.setState({
                selectedCamerasObjectObservation: this.cameraTypes,
            })
        }

        console.debug('selectedCamerasObjectObservation>', this.state.selectedCamerasObjectObservation)

        if (this.grid) {
            this.grid.openCellEditor(rowIdx, idx);
        }
    }

    onCellDeSelected = ({rowIdx, idx}) => {
    }

    deleteRow = () => {
        if (!this.state.selectedIds.length) {
            return;
        }
        let rows = [...this.state.rows];
        rows.splice(this.state.selectedIds[0], 1); //
        let number = 1;
        for (const row of rows) {
            row.priority = number++;
        }
        this.updateRows(rows);
        rows = this.fromSelectValue(rows);
        this.props.handleSave(rows);
    }

    onGridRowsUpdated = ({fromRow, toRow, updated}) => {
        this.setState(state => {
            const rows = state.rows.slice();
            for (let i = fromRow; i <= toRow; i++) {
                rows[i] = {...rows[i], ...updated};
            }
            return {
                isDirty: true,
                rows
            };
        });
    };

    onRowsSelected = rows => {
        this.setState({
            selectedIds: this.state.selectedIds.concat(
                rows.map(r => r.rowIdx)
            )
        });
    };

    onRowsDeselected = rows => {
        let rowIndexes = rows.map(r => r.rowIdx);
        this.setState({
            selectedIds: this.state.selectedIds.filter(
                i => rowIndexes.indexOf(i) === -1
            )
        });
    };

    reorderRows = e => {
        console.debug('reorderRows>');
        let selectedRows = Selectors.getSelectedRowsByKey({
            rowKey: this.props.rowKey,
            selectedKeys: this.state.selectedIds,
            rows: this.state.rows
        });
        let draggedRows = this.isDraggedRowSelected(selectedRows, e.rowSource)
            ? selectedRows
            : [e.rowSource.data];
        let undraggedRows = this.state.rows.filter(function (r) {
            return draggedRows.indexOf(r) === -1;
        });
        let args = [e.rowTarget.idx, 0].concat(draggedRows);
        Array.prototype.splice.apply(undraggedRows, args);

        let number = 1;
        for (const row of undraggedRows) {
            row.priority = number++;
        }

        this.updateRows(undraggedRows);
    };

    isDraggedRowSelected = (selectedRows, rowDragSource) => {
        console.debug('isDraggedRowSelected>')
        if (selectedRows && selectedRows.length > 0) {
            let key = this.props.rowKey;
            return (
                selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0
            );
        }
        return false;
    };

    onRowClick = (rowIdx, row) => {
        this.setState({
            selectedIds: this.state.selectedIds.includes(rowIdx) ?
                [] : [rowIdx]
        });
    }

    updateRows = (newRows) => {
        this.setState({
            isDirty: true,
            rows: newRows
        });
    }

    onDBClickRow = (e) => {
        this.setState({
            modalOpen: true,
            row: this.state.rows[e],
            editingId: e,
        })
    }

    onCloseModal = () => {
        this.setState({modalOpen: false})
    }

    onSubmitModal = (val) => {
        let items = [...this.state.rows];
        if (this.state.editingId !== -1) {
            items[this.state.editingId] = this.formValToFormat(val);
        } else {
            items.push(this.formValToFormat(val));
        }

        items.sort((a, b) =>  {
            return parseInt(a.priority) - parseInt(b.priority);
        });

        this.setState({
            // modalOpen: false,
            rows: items,
            editingId: null,
        },() => {
            const rows = this.fromSelectValue(this.state.rows);
            this.props.handleSave(rows)
        });

    }

    formValToFormat = (item) => {
        const obj = {...item};

        console.log("item", item);
        obj['camera'] = item['camera'].label;
        obj['camera_id'] = item['camera'].value;

        obj['object_observation'] = item['object_observation'].label;
        obj['object_observation_id'] = item['object_observation'].value;

        obj['primary_category'] = item['primary_category'].label;
        obj['primary_category_id'] = item['primary_category'].value;

        obj['secondary_category'] = item['secondary_category'].label;
        obj['secondary_category_id'] = item['secondary_category'].value;

        obj['solution'] = item['solution'].value;
        obj['solution'] = item['solution'].value;

        obj['zone_config'] = item['zone_config'].label;
        obj['zone'] = item['zone_config'].value;

        obj['time_from'] = item['time_from'] === null ? -1 : item['time_from'];
        obj['time_to'] = item['time_to'] === null ? -1 : item['time_to'];

        obj['person_violator_ids'] = [];

        if (item['person_violator_ids'] !== null) {
            item['person_violator_ids'].map(item => obj['person_violator_ids'].push(item.value));
        }

        if (item['minute'] !== "") {
            obj['cron_datetime'] = item['minute'] + ' '
        } else {
            obj['cron_datetime'] = '*' + ' ';
        }
        if (item['hour'] !== "") {
            obj['cron_datetime'] += item['hour'] + ' '
        } else {
            obj['cron_datetime'] += '*' + ' ';
        }
        if (item['day_month'] !== "") {
            obj['cron_datetime'] += item['day_month'] + ' '
        } else {
            obj['cron_datetime'] += '*' + ' ';
        }
        if (item['month'] !== "") {
            obj['cron_datetime'] += item['month'] + ' '
        } else {
            obj['cron_datetime'] += '*' + ' ';
        }
        if (item['day_week'] !== "") {
            obj['cron_datetime'] += item['day_week'] + ' '
        } else {
            obj['cron_datetime'] += '*' + ' ';
        }
        if (item['year'] !== "") {
            obj['cron_datetime'] += item['year']
        } else {
            obj['cron_datetime'] += '*';
        }

        return obj;
    }


    render() {
        const tableHeight = (rows) => {
            let minHeight = 33;
            for (const row of rows) {
                let heightRow = 35;
                if (row.person_violator_ids) {
                    if (row.person_violator_ids.length > 1) {
                        heightRow = row.person_violator_ids.length * 24;
                    }
                }
                minHeight = minHeight + heightRow
            }
            return minHeight;
        }
        return (
            <div>
                <div className="btn-wrapper">
                    <button className="table-control-btn btn-create" onClick={e => this.addRules(e)}>
                        <FontAwesomeIcon icon={faFile} size="lg" color="#919191"/>
                        Создать
                    </button>
                    <button className="table-control-btn btn-delete"
                            disabled={!this.state.selectedIds.length}
                            onClick={this.deleteRow}>
                        <FontAwesomeIcon icon={faTimes} size="lg" color="#919191"/>
                        Удалить
                    </button>
                </div>
                <div>
                    <DraggableContainer>
                        <TableDataGrid
                            ref={node => this.grid = node}
                            columns={this.columns}
                            rowGetter={i => this.state.rows[i]}
                            rowsCount={this.state.rows.length}
                            onGridRowsUpdated={this.onGridRowsUpdated}
                            enableCellSelect={true}
                            onCellSelected={this.onCellSelected}
                            onCellDeSelected={this.onCellDeSelected}
                            getCellActions={this.getCellActions}
                            rowActionsCell={RowActionsCell}
                            onRowClick={this.onRowClick}
                            minHeight={tableHeight(this.state.rows)}
                            rowRenderer={<RowRenderer onRowDrop={this.reorderRows}/>}
                            // rowRenderer={<ReactDataGrid.Row height={60}/>}
                            onRowDoubleClick={(e) => this.onDBClickRow(e)}
                            rowSelection={{
                                enableShiftSelect: false,
                                onRowsSelected: this.onRowsSelected,
                                onRowsDeselected: this.onRowsDeselected,
                                selectBy: {
                                    indexes: this.state.selectedIds
                                }
                            }}
                                                    />
                    </DraggableContainer>
                </div>
                {/*<div className="btn-wrapper bottom-btn">*/}
                {/*    <button className="table-control-btn" type="button"*/}
                {/*            disabled={!this.state.isDirty}*/}
                {/*            onClick={e => this.preSave(e)}>*/}
                {/*        Сохранить*/}
                {/*    </button>*/}
                {/*</div>*/}
                {this.state.modalOpen &&
                <Modal
                    title={`Матрица параметров детектирования`}
                    isOpen
                    className="user-modal"
                    onClose={this.onCloseModal}>
                    <DecisionMatrixForm
                        row={this.state.row}
                        objects={this.props.objects}
                        primaryCategories={this.props.modelstorage.primary_categories}
                        secondaryCategories={this.props.modelstorage.secondary_categories}
                        employees={this.props.employees}
                        zones={this.props.modelstorage.config_zones}
                        cameras={this.props.cameras}
                        onSubmit={(val) => {
                            this.onSubmitModal(val);
                        }}
                    />
                </Modal>}
            </div>
        );
    }
}

export default DecisionMatrixTableForm;
